'use client'

import Section from '../molecules/section';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

const WhatsNew = () => {
    const t = useTranslations('WhatsNew');
    return (
        <Section
            id="whatsnew"
            backgroundImage="/images/whats-new.avif"
            className="relative flex flex-col min-h-screen items-center justify-center bg-no-repeat bg-cover"
        >
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black opacity-50"></div>

            {/* Top gradient */}
            <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

            {/* Bottom gradient */}
            <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

            <div className="relative flex flex-col items-center text-center pt-8 ">
                <h2 className="text-4xl font-bold leading-none leading-10 font-sora text-white mt-28 mb-20 text-center lg:w-[60%] whitespace-nowrap">
                    {t('title')}
                </h2>
                <h2 className="text-4xl font-bold leading-none leading-10 font-sora text-white text-center lg:w-[60%] whitespace-nowrap">
                    {t('sections.shibayaStation.subTitle')}
                </h2>
                <p className="m-auto text-white text-base font-normal leading-6 tracking-[0.02em] sm:w-[100%] md:w-[80%] lg:w-[40%] mt-2 font-sora py-6">
                    {t('sections.shibayaStation.description')}
                </p>
                <Image
                    src="/images/shibaya-station.avif"
                    width={1000}
                    height={500}
                    className="rounded-3xl mb-4 px-4 lg:px-0 sm:w-[100%] md:w-[90%] lg:w-[90%] h-[32rem] object-cover"
                    alt="shibaya-station-logo"
                />
                <div className='flex flex-col lg:flex-row space-y-4 justify-center items-center mt-40 my-32'>
                    <div className='w-full lg:w-1/2 flex flex-col items-center justify-center space-y-4'>
                        <h2 className="text-4xl font-bold leading-6 tracking-[0.02em] font-sora text-white w-full  sm:text-center md:text-center lg:text-left sm:ml-0 md:ml-0 lg:ml-36 xl:ml-48">
                            {t('sections.avatarBuilder.subTitle')}
                        </h2>
                        <p className="text-white sm:text-center md:text-left lg:text-left text-base font-normal leading-6 tracking-[0.02em] mt-2 font-sora sm:w-[80%] md:w-[80%] lg:w-[65%] sm:lg-0 md:lg-0 lg:mr-36">
                            {t('sections.avatarBuilder.description')}
                        </p>
                    </div>
                    <div className='w-full lg:w-1/2 flex flex-col items-center justify-center space-y-4'>
                        <div className='flex justify-center'>
                            <Image
                                src="/images/avatar-builder.avif"
                                width={500}
                                height={250}
                                className="rounded-3xl mb-4 px-4 lg:px-0 w-full lg:w-[78%] h-auto"
                                sizes="100%"
                                alt="avatar-builder"
                            />
                        </div>
                        <div className='flex justify-center'>
                            <Image
                                src="/images/avatar-builder2.avif"
                                width={500}
                                height={250}
                                className="rounded-3xl mb-4 px-4 lg:px-0 w-full lg:w-[78%] h-auto"
                                sizes="100%"
                                alt="avatar-builder2"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    );
};

export default WhatsNew;